import React from "react";
import sintexLogo from "../assets/about_page_sintex_logo.png";

// Inline SVG logo matching the SINTX "X" mark with gradient
const SintxLogo = () => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="xGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#129ADC" />
        <stop offset="40%" stopColor="#B55DD0" />
        <stop offset="70%" stopColor="#E154AA" />
        <stop offset="100%" stopColor="#F45A39" />
      </linearGradient>
    </defs>
    {/* Left arc */}
    <path
      d="M14 12 C14 12, 30 36, 14 60"
      stroke="url(#xGrad)"
      strokeWidth="7"
      strokeLinecap="round"
      fill="none"
    />
    {/* Right arc */}
    <path
      d="M58 12 C58 12, 42 36, 58 60"
      stroke="url(#xGrad)"
      strokeWidth="7"
      strokeLinecap="round"
      fill="none"
    />
    {/* Top cross bar left-to-right */}
    <path
      d="M20 20 C28 28, 44 28, 52 20"
      stroke="url(#xGrad)"
      strokeWidth="7"
      strokeLinecap="round"
      fill="none"
    />
    {/* Bottom cross bar left-to-right */}
    <path
      d="M20 52 C28 44, 44 44, 52 52"
      stroke="url(#xGrad)"
      strokeWidth="7"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

// Gradient divider line matching the brand gradient
const GradientDivider = () => (
  <div
    style={{
      width: 220,
      height: 2,
      borderRadius: 99,
      background: "linear-gradient(90deg, #129ADC, #B55DD0, #E154AA, #F45A39)",
      margin: "18px auto 0",
    }}
  />
);

const AboutSection = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

        .about-section {
          position: relative;
          background: #ffffff;
          padding: 72px 24px 120px;
          text-align: center;
          font-family: 'Poppins', sans-serif;
          overflow: hidden;
        }

        /* Large circle arc at the bottom */
        .about-section::after {
            content: '';
            position: absolute;
            top: -37vw; /* controls curve height */
            left: 50%;
            transform: translateX(-50%);
            width: 109vw; /* wider than screen */
            height: stretch;
            border-radius: 50%;
            background: #e8edf4;
            z-index: 0;
            }

        .about-inner {
          position: relative;
          z-index: 1;
          max-width: 60vw;
          margin: 0 auto;
          padding: 20px 20px;
        }

        .sintx-wordmark {
          font-family: 'Poppins', sans-serif;
          font-weight: 400;
          font-size: 1.45rem;
          letter-spacing: 0.55em;
          color: #111827;
          text-transform: uppercase;
          margin-top: 14px;
          margin-bottom: 0;
        }

        .about-headline {
          font-family: 'Poppins', sans-serif;
          font-weight: 700;
          font-size: clamp(1.1rem, 2.5vw, 1.45rem);
          color: #111827;
          margin: 56px 0 0;
          line-height: 1.4;
        }

        .about-subtext {
          font-family: 'Poppins', sans-serif;
          font-size: 0.92rem;
          font-weight: 400;
          color: #374151;
          line-height: 1.8;
          margin: 28px 0 0;
        }

        .about-body {
          font-family: 'Poppins', sans-serif;
          font-size: 0.92rem;
          font-weight: 400;
          color: #374151;
          line-height: 1.9;
          margin: 22px 0 0;
        }

        .about-body strong {
          font-weight: 700;
          color: #111827;
        }
      `}</style>

      <section className="about-section">
        <div className="about-inner">
          {/* Logo mark */}
          <img src={sintexLogo} alt="SINTX Logo" style={{ width: 150, margin: "0 auto" }} />

          {/* Headline */}
          <h2 className="about-headline">
            The name SINTX comes from the word "Syntax"
          </h2>

          {/* Gradient underline */}
          <GradientDivider />

          {/* Sub paragraph */}
          <p className="about-subtext">
            in programming language, it means structure and clarity. Just like
            syntax helps code run correctly and makes it easy to understand,
            SINTX focuses on creating designs that are clean, well-structured,
            and meaningful
          </p>

          {/* Body paragraph */}
          <p className="about-body">
            <strong>SINTX</strong> is a creative design studio focused on
            building strong brands and high-performing digital experiences. We
            specialize in branding, UI/UX design, graphic design, packaging
            design, and social media creatives — helping startups and businesses
            create a powerful, consistent, and modern visual presence. Our
            approach is simple: design with clarity, purpose, and performance.
            From logo design and complete brand identity to modern websites and
            conversion-focused UI, we create solutions that not only look
            visually strong but also drive real business results.
          </p>
        </div>
      </section>
    </>
  );
};

export default AboutSection;
